import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const slides = [
  { src: "/menu1.png", alt: "メニュー 1" },
  { src: "/menu4.png", alt: "メニュー 4" },
  { src: "/menu2.png", alt: "メニュー 2" },
  { src: "/menu3.png", alt: "メニュー 3" },
];

export default function MenuSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((i) => (i - 1 + slides.length) % slides.length);
  const next = () => setCurrent((i) => (i + 1) % slides.length);

  return (
    <section id="menu" className="relative w-full py-20 md:py-32 bg-warm-950">
      <div className="max-w-[1000px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 md:mb-14"
        >
          <span className="inline-block px-4 py-1.5 text-xs md:text-sm font-sans font-medium tracking-super-wide text-warm-400 bg-warm-800 border border-warm-700 rounded-full mb-4">
            MENU
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-warm-50">
            お品書き
          </h2>
        </motion.div>

        {/* Slider */}
        <div className="relative max-w-lg mx-auto rounded-2xl overflow-hidden">
          {/* 全スライドを重ねて表示、currentのみ見せる */}
          <div className="relative w-full">
            <img
              src={slides[current].src}
              alt={slides[current].alt}
              className="w-full object-contain invisible"
              aria-hidden
            />
            <AnimatePresence mode="sync">
              <motion.img
                key={current}
                src={slides[current].src}
                alt={slides[current].alt}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.25 }}
                className="absolute inset-0 w-full h-full object-contain"
              />
            </AnimatePresence>
          </div>

          {/* Prev */}
          <button
            onClick={prev}
            className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/40 hover:bg-black/60 flex items-center justify-center text-white transition-colors z-10"
            aria-label="前へ"
          >
            <i className="ri-arrow-left-s-line text-xl" />
          </button>

          {/* Next */}
          <button
            onClick={next}
            className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/40 hover:bg-black/60 flex items-center justify-center text-white transition-colors z-10"
            aria-label="次へ"
          >
            <i className="ri-arrow-right-s-line text-xl" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-5">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`w-2 h-2 rounded-full transition-colors ${
                i === current ? "bg-amber-500" : "bg-warm-600"
              }`}
              aria-label={`スライド ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
